module.exports = "/assets/4299f68a6728799a5e3c817f55b36cac.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/F7.png
// module id = 1360
// module chunks = 0